module.exports = __webpack_public_path__ + "img/IconRno.cc15517c.svg";